export default __webpack_public_path__ + "static/teamwork-9f2ee34d8d47d09657c6ec53fb69f0a1.jpg";